import {
  Users, Stethoscope, ShieldCheck, Heart, Baby, Activity, Scan, Droplet,
  ClipboardList, Syringe, Brain, Bone, Eye, HeartPulse, Microscope, Pill,
} from "lucide-react";

const MAP = {
  users: Users, stethoscope: Stethoscope, "shield-check": ShieldCheck, heart: Heart,
  baby: Baby, activity: Activity, scan: Scan, droplet: Droplet, "clipboard-list": ClipboardList,
  syringe: Syringe, brain: Brain, bone: Bone, eye: Eye, "heart-pulse": HeartPulse,
  microscope: Microscope, pill: Pill,
};

export const ServiceIcon = ({ name, ...props }) => {
  const Icon = MAP[name] || Stethoscope;
  return <Icon {...props} />;
};

export const ICON_OPTIONS = Object.keys(MAP);
